import styled from "styled-components";

export const StyledContainer = styled("div")<any>`
  position: relative;
  width: 100%;
  width: 100vw;
  margin-right: auto;
  margin-left: auto;
  padding: 0 60px;
  background: rgb(0,184,255);
  border-top: ${(p) => (p.border ? "1px solid #CDD1D4" : "")};

`;
